import styled from "@emotion/styled";

export const ImageForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EmptyImage = styled.div`
  cursor: pointer;
  display: flex;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--component-color-fill-normal);
`;

export const RoomImageContainer = styled.img`
  display: flex;
  flex-direction: column;
  height: 320px;
  width: 100%;
  border: 1px solid var(--alias-color-line-normal);
  border-radius: 16px;
  position: relative;
  object-fit: cover;
`;

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
`;
